import{ useState, forwardRef, useImperativeHandle } from 'react';
import { Alert, IconButton, Snackbar } from '@mui/material';
import useMediaQuery from '../../base/useMediaQuery';
import { Close } from '@mui/icons-material';

const SnackBarDialog = forwardRef((props, ref) => {
    const isDeskTop = useMediaQuery('(min-width: 400px)');

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [type, setType] = useState("info");
    const [action, setAction] = useState(null);
    const [timeout, setTimeout] = useState(6000);

    useImperativeHandle(ref, () => ({
        show({ action, message, timeout, type }) {
            setMessage(message);
            setAction(action);
            if (type) setType(type);
            if (timeout) setTimeout(timeout);
            setOpen(true);
        },
        hide() {
            handleClose();
        }
    }));

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
    };

    const renderAction = () => {

        return (
            <div className='flex items-center gap-1'>
                {action}
                <IconButton onClick={handleClose} size="small" className='text-white'>
                    <Close fontSize='sm' className='text-white' />
                </IconButton>
            </div>
        )
    }

    return (
        <>
            <Snackbar
                open={open}
                className='z-[99999999]'
                autoHideDuration={timeout}
                onClose={handleClose}
                action={action}
            >
                <Alert className='flex items-center' action={renderAction()} onClose={handleClose} severity={type} variant="filled" sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    );
})

export default SnackBarDialog;